import React from "react";
import { LoginResponseModel } from "../../services/client";

// By adding {partner_id?: string} we ensure we can always access
// it, even for admin-only tokens but it will just be null there
type User = LoginResponseModel["user"] & { partner_id?: string };

export const decodeToken = (token: string) => {
  return JSON.parse(atob(token!.split(".")[1]));
};

export const AuthenticatedUser = React.createContext<User | null>(null!);

export const useAuthenticatedUser = (): User | null => {
  const user = React.useContext(AuthenticatedUser);
  if (user) {
    return user;
  }
  const token = localStorage.getItem("token");
  if (token != null) {
    return decodeToken(token);
  }
  return null;
};
